/**
 * Created by Ning Jiang on 3/27/2017.
 */

import {GameMode, IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export interface IWixxGameModeChangedData extends IGameModeChangedData {
    feature:string;
    updateBoostedSymbols?:boolean;
}

export class WixxGameMode extends GameMode{

    public static readonly RED_BOOSTER:string = "RED_BOOSTER";
    public static readonly YELLOW_BOOSTER:string = "YELLOW_BOOSTER";
    public static readonly BLUE_BOOSTER:string = "BLUE_BOOSTER";
    public static readonly RED_YELLOW_BOOSTER:string = "RED_YELLOW_BOOSTER";
    public static readonly RED_BLUE_BOOSTER:string = "RED_BLUE_BOOSTER";
    public static readonly YELLOW_BLUE_BOOSTER:string = "YELLOW_BLUE_BOOSTER";
}